import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './RecaptchaPolicies.css';

const RecaptchaPolicies = () => {
	const { t } = useTranslation();

	const html = useMemo(() => {
		const translation = t('Google recaptcha policies notice');
		const privacyAnchor = `<a target="_blank" rel="noopener noreferrer" href="https://policies.google.com/privacy">${t(
			'Google Privacy Policy',
		)}</a>`;
		const termsAnchor = `<a target="_blank" rel="noopener noreferrer" href="https://policies.google.com/terms">${t(
			'Terms of Service',
		)}</a>`;
		const html1 = translation.replace('Google Privacy Policy', privacyAnchor);
		const html2 = html1.replace('Terms of Service', termsAnchor);
		return html2;
	}, [t]);

	return <div className='recaptcha-policies' dangerouslySetInnerHTML={{ __html: html }} />;
};

export { RecaptchaPolicies };
